import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ImssService {
  constructor(private http: HttpClientService) {}

  public request_nss(person_id): Observable<any> {
    const options = {
      person_id: person_id,
    };
    return this.http.post("/api/imss", options).pipe(tap((_) => console.log("ImssService.request_nss: Ok.")));
  }

  public request_sdk_token(): Observable<any> {
    return this.http
      .post("/api/imss/sdk_token", null)
      .pipe(tap((_) => console.log("ImssService.request_sdk_token: Ok.")));
  }

  public postImssDataByHand({
    person_id = undefined,
    application_id = undefined,
    nss = undefined,
    employer_name = undefined,
    base_salary = undefined,
    company_imss_id = undefined,
    starting_date = undefined,
    ending_date = undefined,
    total_weeks = undefined,
  }): Observable<any> {
    const params = {
      person_id,
      application_id,
      nss,
      employer_name,
      base_salary,
      company_imss_id,
      starting_date,
      ending_date,
      total_weeks,
    };
    return this.http
      .post("/api/imss/create_data_by_hand", params)
      .pipe(tap((_) => console.log("ImssService.postImssDataByHand: Ok.")));
  }
}
